import { Item } from 'containers/InvestorManagement/components'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'
import { removeHttp } from 'utils/functions/strings'
import { InvestmentVehicleSubjectData } from 'utils/hooks/subjects/useInvestmentVehicleSubjectData'
import { InvestorSubjectData } from 'utils/hooks/subjects/useInvestorSubjectData'
import { AdditionInformation } from '../CompanyHeader/HeaderAdditionalInformation.styles'

interface Props {
  investor: InvestorSubjectData
  isShowingInvestmentVehicle?: boolean
  investmentVehicle?: InvestmentVehicleSubjectData
}

const HeaderAdditionalInformation = ({
  investor,
  isShowingInvestmentVehicle,
  investmentVehicle,
}: Props) => {
  const intl = useIntl()
  const shareInvestorData = investmentVehicle?.useInvestorInformation

  return (
    <AdditionInformation padding="1.8rem 0 0 0">
      {!!investor.emails.length && (
        <Item
          isDark
          icon={['far', 'envelope']}
          value={removeHttp(investor.emails[0])}
          type="darkLink"
          maxLines={1}
          id="investor_email"
        />
      )}

      {investor.website && (
        <Item
          isDark
          icon={['far', 'link']}
          value={removeHttp(investor.website)}
          type="darkLink"
          href={investor.website}
          maxLines={1}
          id="investor_website"
          topOffset={50}
          leftOffset={250}
        />
      )}

      {isShowingInvestmentVehicle && !shareInvestorData
        ? investmentVehicle?.phone && (
            <Item
              icon={['far', 'phone-alt']}
              value={investmentVehicle.phone}
              type="text"
            />
          )
        : investor.phone && (
            <Item
              icon={['far', 'phone-alt']}
              value={investor.phone}
              type="text"
            />
          )}

      {isShowingInvestmentVehicle && !shareInvestorData
        ? investmentVehicle?.address && (
            <Item
              icon={['far', 'map-marker-alt']}
              value={investmentVehicle?.address}
              type="text"
            />
          )
        : investor.address && (
            <Item
              icon={['far', 'map-marker-alt']}
              value={investor.address}
              type="text"
            />
          )}

      {investor.foundedDate && (
        <Item
          icon={['far', 'birthday-cake']}
          value={intl.formatMessage(
            {
              id: 'investorManagement.profiles.foundedDate',
            },
            { date: dayjs(investor.foundedDate).format('MMMM YYYY') }
          )}
          type="text"
        />
      )}

      {!isShowingInvestmentVehicle && (
        <>
          {!!investor.teamSize && (
            <Item
              icon={['far', 'users']}
              value={intl.formatMessage(
                {
                  id: 'investorManagement.profiles.teamSize',
                },
                { employeesCount: investor.teamSize }
              )}
              type="text"
            />
          )}

          {investor.legalName && (
            <Item
              icon={['far', 'list-ul']}
              value={investor.legalName}
              type="text"
            />
          )}

          {!!investor.industries.length && (
            <Item
              isDark
              icon={['far', 'industry-alt']}
              value={investor.industries.map((ind) => ind.name).join(', ')}
              type="tooltip"
              maxLines={3}
            />
          )}
        </>
      )}
    </AdditionInformation>
  )
}

export default HeaderAdditionalInformation
